import React from 'react';
import { I18n } from '@boschebike/ebds-js/dist-esm/helpers/i18n.js';
import { dictionaryContainsLanguage, getDictionary } from '../../content/translations.js';
import { ComponentServiceIncludeIdle } from './private/componentServiceIncludeIdle.js';
import { ComponentServiceIncludeMaintenance } from './private/componentServiceIncludeMaintenance.js';

const atobPolyfill = (string) => {
  try {
    // eslint-disable-next-line no-undef
    if (globalThis.Buffer) {
      // eslint-disable-next-line no-undef
      return globalThis.Buffer.from(string, 'base64').toString();
    }

    return atob(string);
  } catch (error) {
    console.warn('Could not decode edge content', error);
    return '';
  }
};

/**
 * @param {{ edgeContent: string }} props
 */
const ComponentServiceIncludeDefault = ({ edgeContent }) => (
  <div
    dangerouslySetInnerHTML={{ __html: atobPolyfill(edgeContent) }}
    suppressHydrationWarning
  />
);

/**
 * @typedef {import('../../App.d.ts').ComponentServiceIncludeExtended} ComponentServiceIncludeExtended
 */
/**
 * @param {ComponentServiceIncludeExtended} props
 */
const ComponentServiceIncludeExtended = ({
  edgeContent,
  supportsIdle,
  lang,
}) => {
  const currentLang = dictionaryContainsLanguage(lang) ? lang : 'en-GB';
  const i18n = new I18n(currentLang, getDictionary(currentLang));

  if (!supportsIdle) {
    return null;
  }

  return (
    <dodo-service-include
      class="dodo-service-include dodo-service-include--loading"
      suppressHydrationWarning
    >
      <ComponentServiceIncludeIdle
        atobPolyfill={atobPolyfill}
        edgeContent={edgeContent}
        i18n={i18n}
      />
      <ComponentServiceIncludeMaintenance i18n={i18n} />
    </dodo-service-include>
  );
};

/**
 * @param {ComponentServiceIncludeExtended} props
 */
export default ({
  edgeContent,
  supportsIdle = false,
  lang,
}) => {
  if (supportsIdle) {
    return (
      <ComponentServiceIncludeExtended
        data-testid="service-include-extended"
        edgeContent={edgeContent}
        supportsIdle={supportsIdle}
        lang={lang}
      />
    );
  }

  return (
    <ComponentServiceIncludeDefault
      data-testid="service-include-default"
      edgeContent={edgeContent}
    />
  );
};
